import React from "react";
import "../Hero.css";
import { NavLink } from "react-router-dom";
import heroImage from "../../../assets/hero.svg";


import {
    FiArrowRight,
    FiArrowDown,
    FiCheckCircle,
    FiShoppingCart,
    FiSmartphone,
    FiLayers,
    FiTrendingUp,
} from "react-icons/fi";

const Hero = () => {
    return (
        <section className="hero">

            <div className="container hero-container">

                {/* ================= LEFT ================= */}

                <div className="hero-content">

                    <span className="hero-badge">
                        Transforming Businesses Through Digital Commerce
                    </span>

                    <h1>
                        Build Powerful
                        <span> E-Commerce Platforms </span>
                        That Grow Your Business
                    </h1>

                    <p>
                        Kishancart Digital (OPC) Private Limited helps startups,
                        retailers and enterprises build modern e-commerce platforms,
                        multi-vendor marketplaces, mobile applications and digital
                        solutions that drive sales and business growth.
                    </p>

                    {/* CTA Buttons */}

                    <div className="hero-buttons">

                        <a
                            href="/contact"
                            className="hero-primary-btn"
                        >
                            Get Free Consultation
                            <FiArrowRight />
                        </a>

                        <a
                            href="#get-started"
                            className="hero-secondary-btn"
                        >
                            Get Started
                            <FiArrowDown />
                        </a>

                    </div>

                    {/* Features */}

                    <div className="hero-features">

                        <div className="feature-item">
                            <FiCheckCircle />
                            E-commerce Development
                        </div>

                        <div className="feature-item">
                            <FiCheckCircle />
                            Marketplace Solutions
                        </div>

                        <div className="feature-item">
                            <FiCheckCircle />
                            Mobile Apps
                        </div>

                        <div className="feature-item">
                            <FiCheckCircle />
                            Digital Marketing
                        </div>

                    </div>

                </div>

                {/* ================= RIGHT ================= */}

                <div className="hero-image">

                    <img
                        src={heroImage}
                        alt="Kishancart Digital"
                    />

                    {/* Floating Cards */}

                    <div className="floating-card card-one">
                        <FiShoppingCart />
                        <div>
                            <h4>Retail Commerce</h4>
                            <p>Custom E-Commerce Platforms</p>
                        </div>
                    </div>

                    <div className="floating-card card-two">
                        <FiLayers />
                        <div>
                            <h4>Marketplace</h4>
                            <p>B2B & Multi-Vendor Solutions</p>
                        </div>
                    </div>

                    <div className="floating-card card-three">
                        <FiTrendingUp />
                        <div>
                            <h4>Digital Growth</h4>
                            <p>SEO, Marketing & Business Solutions</p>
                        </div>
                    </div>

                </div>

            </div>

            {/* ================= STATS ================= */}

            <div className="container" id="get-started">

                <div className="hero-stats">

                    <div className="stat-card">

                        <FiShoppingCart />

                        <h3>E-Commerce</h3>

                        <p>
                            Custom online stores with secure payment gateways and scalable architecture.
                        </p>

                    </div>

                    <div className="stat-card">

                        <FiLayers />

                        <h3>Marketplace</h3>

                        <p>
                            Multi-vendor marketplace solutions for B2B, B2C and retail businesses.
                        </p>

                    </div>

                    <div className="stat-card">

                        <FiSmartphone />

                        <h3>Mobile Apps</h3>

                        <p>
                            Android and iOS applications built for seamless shopping experiences.
                        </p>

                    </div>

                    <div className="stat-card">

                        <FiTrendingUp />

                        <h3>Digital Growth</h3>

                        <p>
                            SEO, digital marketing and business solutions to accelerate online growth.
                        </p>

                    </div>

                </div>

            </div>

        </section>
    );
};

export default Hero;